<template>
  <div class="page">
    <p class="p1">
      积分兑换
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div class="search-box">
      <input type="text" v-model="queryParams.iccid" class="search-input" placeholder="请选择需要兑换的卡号" @click="openSwitch('isVisible')" onfocus="this.blur()" :disabled="inputDisabled">
    </div>
    <div class="detail-box">
      <ul>
        <li class="li_class" v-for="(item,index) in dataList" :key="index">
          <p>
            <span>{{item.productName}}</span>
            <span>所需积分：{{item.integral}}</span>
          </p>
          <p>
            <span>有效期：{{item.validityTime + "天"}} </span>
            <nut-button small @click="cardUnbound(item.productId)">兑换</nut-button>
          </p>
        </li>
      </ul>
    </div>
    <!-- 选择卡的数据 -->
    <nut-picker 
      :is-visible="isVisible" 
      :list-data="listData" 
      :default-value-data="defaultValueData" 
      @close="closeSwitch('isVisible')" 
      @confirm="confirm"
    ></nut-picker>
  </div>
</template>
<script>
import { wx_integralExchangeList } from "@/api/api.js"; 
import { wx_integralExchange } from "@/api/api.js"; 
export default {
  data() {
    return {
      queryParams:{
        iccid:"",
      },
      inputDisabled:false,
      dataList:[],
      option: '请选择',
      isVisible: false,
      listData: [],
      defaultValueData: []
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    initData(){
      wx_integralExchangeList().then(res => {
        if(res.data.code == 200){
          this.listData = res.data.data.pickList;
          this.dataList = res.data.data.productList
        }
      })
    },
    // 账户积分兑换
    openSwitch(param){
      this[`${param}`] = true;
    },
    // 取消选择
    closeSwitch(param){
      this[`${param}`] = false;
    },
    // 确认选择
    confirm(chooseData) {
      this.queryParams.iccid = `${chooseData[0].value}`
    },
    // 积分兑换套餐按钮
    cardUnbound(val){
      if(!this.queryParams.iccid){
        this.$toast.warn('请选择卡号');
      }else{
        let that = this;
        this.$dialog({
          title: "确定要兑换此套餐吗？",
          onOkBtn(event) { 
            if(that.$route.query.type == 1){
              let params = {
                type:1,
                iccid:that.queryParams.iccid,
                productId:val
              }
              wx_integralExchange(params).then(res => {
                if(res.data.code == 200){
                  this.close();
                  this.$toast.success('兑换成功，跳转中');
                  setTimeout(()=>{
                    that.$router.push({
                      name: "userCenterPersona",
                    })
                  },2000)
                }else{
                  this.close();
                  this.$toast.fail(res.data.message);
                }
              })
            }else{
              let params = {
                type:2,
                iccid:that.queryParams.iccid,
                productId:val
              }
              wx_integralExchange(params).then(res => {
                if(res.data.code == 200){
                  this.close();
                  this.$toast.success('兑换成功，跳转中');
                  setTimeout(()=>{
                    that.$router.push({
                      name: "userCenterPersona",
                    })
                  },2000)
                }else{
                  this.close();
                  this.$toast.fail(res.data.message);
                }
              })
            }
          }
        })
      }
    }
  },
  created() {
    this.initData();
    if(this.$route.query.type == "1"){
      this.inputDisabled = false;
    }else{
      this.inputDisabled = true;
      this.queryParams.iccid = this.$route.query.iccid;
    }
  },
  mounted() {
    window.document.title = "积分兑换";
  }, 
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }
    .search-box {
      margin: 5% auto 15px;
      text-align: center;
      border: none;
    }
    .search-input {
      width: 90%;
      height: 40px;
      line-height: 40px;
      border: 1.2px solid #999;
      border-radius: 5px;
      text-indent: 15px;
      outline: none;
      font-size: 14px;
    }
    .detail-box{
      width: 100%;
      margin-top: 25px;
    }
    .li_class{
      padding: 0px 19px;
      background: #fff;
      width: 100%;
      font-size: 13px;
      border-bottom: 2px solid #ededed;
      p{
        display: flex;
        justify-content: space-between;
        margin: 5px 0;
        /deep/ .nut-button.small{
          height: 25px;
          padding: 0 10px;
          font-size: 12px;
          border-radius:5px;
          background:#F94040;
        }
      }
    }
  }
</style>

